import { render, staticRenderFns } from "./PoliticaTratamiento.vue?vue&type=template&id=065381c8&"
import script from "./PoliticaTratamiento.vue?vue&type=script&lang=js&"
export * from "./PoliticaTratamiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports